import React from 'react';

import { useTranslation } from 'react-i18next';

import s from './BackStep.module.css';
import { BackStepItem } from './BackStepItem';

export const BackStep = ({ step, stepBack }) => {
    const { t } = useTranslation();
    return (
        <div>
            {step === 0 && (
                <a href={ENV.BASE_URL} data-id="back-site" className={s.backItemWrapper}>
                    <BackStepItem text={t('BackStep.BackStepItem.back_to_site')} />
                </a>
            )}
            {step !== 0 && step < 3 && (
                <div onClick={stepBack} data-id="back-item" className={s.backItemWrapper}>
                    <BackStepItem text={t('BackStep.BackStepItem.back')} />
                </div>
            )}
        </div>
    );
};
